package com.jingfangpai.common.data.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.js.JsName

//@Serializable
// data class CascadedOption<T: Any>(@SerialName("label")var label:String = "", @SerialName("value")var value:T? = null, var disabled:Boolean = false, @SerialName("children")var children:Array<CascadedOption<T>>? = arrayOf()){
//    constructor( label:String = "",  value:T? = null):this(label,value,false,arrayOf())
//}

@Serializable
class CascadedOption<T: Any>(){
    @JsName("label")
    var label:String = ""
    @JsName("value")
    var value:T? = null
    @JsName("disabled")
    var disabled:Boolean = false
    @JsName("children")
    var children:Array<CascadedOption<T>>? = arrayOf()
    constructor( label:String = "",  value:T? = null):this(label,value,false,arrayOf())
    constructor( label:String = "",  value:T? = null,  disabled:Boolean = false,  children:Array<CascadedOption<T>>? = arrayOf()):this(){
        this.label = label;
        this.value = value;
        this.disabled = disabled;
        this.children = children;
    }

    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other == null || this::class != other::class) return false

        other as CascadedOption<*>

        if (label != other.label) return false
        if (value != other.value) return false
        if (disabled != other.disabled) return false
        if (children != null) {
            if (other.children == null) return false
            if (!children.contentEquals(other.children)) return false
        } else if (other.children != null) return false

        return true
    }

    override fun hashCode(): Int {
        var result = label.hashCode()
        result = 31 * result + (value?.hashCode() ?: 0)
        result = 31 * result + disabled.hashCode()
        result = 31 * result + (children?.contentHashCode() ?: 0)
        return result
    }

}
